import { c as _c } from "react/compiler-runtime";
import { getStoredMarkupsCalendarPreferences, storeMarkupsCalendarPreferences } from "@pages/project-details/project-markups/calendar/project-markups-calendar-utils";
import { useSyncExternalStore } from "react";

/** Components to notify when the preferences change, so the calendar and the KPI bar stay in sync */
const listeners = new Set();

/** Preferences read once from the local storage, as the snapshot must not change between reads */
let cachedPreferences;
function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
function getSnapshot() {
  cachedPreferences ??= getStoredMarkupsCalendarPreferences();
  return cachedPreferences;
}
function setPreferences(preferences) {
  cachedPreferences = preferences;
  storeMarkupsCalendarPreferences(preferences);
  listeners.forEach(listener => listener());
}

/** Returns the preferences of the annotations calendar, stored in the local storage, and a function to change them */
export function useMarkupsCalendarPreferences() {
  const $ = _c(2);
  const t0 = useSyncExternalStore(subscribe, getSnapshot);
  let t1;
  if ($[0] !== t0) {
    t1 = [t0, setPreferences];
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}